import { DndContext, KeyboardSensor, PointerSensor, closestCenter, useSensor, useSensors } from '@dnd-kit/core';
import { Floor, SortableFloor } from './Floor';
import { SortableContext, arrayMove, sortableKeyboardCoordinates, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { Sortable } from './Sortable';
import { useDispatch, useSelector } from 'react-redux';
import { setFloorOrder } from '../../store/actions/multiFloor';
import { Stack } from '@mui/material';
import { useEffect } from 'react';
import { houseViewService } from '../../lib/signtouch';
import { setHouseView, updateHouseView } from '../../store/actions/houseView';
import addPending from '../../utils/addPending';
import removePending from '../../utils/removePending';

export const MultiFloorFloorsSection = ({ onChange, houseTypeId, multiFloor = true }) => {
  const dispatch = useDispatch();
  const houseView = useSelector(state => state.houseView.filter(house => house.houseTypeId === parseInt(houseTypeId)))[0];
  const floors = houseView.floors.sort((a, b) => a.order - b.order);
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleDragEnd = event => {
    const {active, over} = event;
    
    if (active.id !== over.id) {
      const ids = floors.map(floor => floor.id);
      const oldIndex = ids.indexOf(active.id);
      const newIndex = ids.indexOf(over.id);
      const newOrder = arrayMove(floors, oldIndex, newIndex);

      const newFloors = newOrder.map((floor, index) => {
        return {
          ...floor,
          order: index + 1
        }
      });
      if (multiFloor) {
        dispatch(setFloorOrder(newFloors));
      }
      onChange(newFloors);
    }
  }
  const handleDeleteFloor = async (id) => {
    const pendingToast = addPending('deleting floor')
    const newFloors = floors.filter(floor => floor.id !== id);
    await houseViewService.updateHouseView({ floors: [...newFloors]}, houseView.id)
    .then((r) => {
      dispatch(updateHouseView(r));
      onChange(newFloors);
      removePending(pendingToast);
    });
  };
  useEffect(() => {
  }, [houseTypeId, removePending]);

  return (
    <Stack direction="column" alignItems="stretch" flexGrow={1}>
      <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
        <SortableContext items={floors} strategy={verticalListSortingStrategy}>
          {houseTypeId && 
          houseView.floors && houseView.floors.map((floor) => (
            <SortableFloor key={floor.id} id={floor.id} houseTypeId={houseTypeId} label={floor.name} onDelete={handleDeleteFloor} />
          ))
          }
        </SortableContext>
      </DndContext>
    </Stack>
  );
};
